import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import { useLocation } from 'react-router-dom';
import { setUser, setToken } from '../../redux/actions';
import { url, history } from '../../utils/variables';
import LoginComponent from '../../components/master/LoginComponent';
import header from '../../assets/images/header.png';
import logo from '../../assets/images/logo.png';
import loginFooter from '../../assets/images/loginFooter.png';
import GolrangeLogo from '../../assets/images/g3se0(2).png';
import { useTranslation } from 'react-i18next';

export default function Login() {

    const { i18n } = useTranslation();
    const location = useLocation();
    const insuranceLogo = location.search && location.search.replace('?', '');

    const dispatch = useDispatch();

    function getData(data) {
        dispatch(setUser(data.user));
        dispatch(setToken(data.token));
        history.replace('/');
    }
    //*
     const { user } = useSelector(store => store);
    useEffect(()=>{
        // const check = ()=>{
        //     if(user.type)
        //         history.replace('/');
        // }
        // check();
        !user.type && i18n.changeLanguage('fa');
        user.type && history.replace('/');
    },[user])

    return (
        <div className='login'>
            <img src={header} alt='header' className='headerImage'/>
            <div className='content'>
                <div className='text-center'>
                    {
                        insuranceLogo
                            ? <img src={`${url}/images/insurances/header/${insuranceLogo}.png`} className='insuranceImages' alt='logo'/>
                            : <img src={logo} alt='logo' className='logo'/>
                    }
                    <div className='mt30'>
                        <LoginComponent
                            getData={getData}
                        />
                    </div>
                    {
                        insuranceLogo === 'g3se0'
                        ?
                        <div className='logoSlide'>
                            <img className='mt30 ' src={GolrangeLogo} alt='logo'/>  
                        </div>
                        :
                        insuranceLogo &&
                        <img className='mt30 insuranceImages' src={`${url}/images/insurances/footer/${insuranceLogo}.png`} alt='logo'/>
                    }

                    <div className='text-center version'>
                        <h6 style={{color:"#ada6a6"}}>3.0.9</h6>
                    </div>
                </div>
            </div>
            <img src={loginFooter} alt='header' className='headerImage'/>
        </div>
    );

}
